import React from 'react';

// Stavka liste koja je pravi link (<a href>) da pretraživači mogu da je prate,
// a običan klik i dalje radi kao ranije (SPA navigacija preko onActivate).
// Ctrl/Cmd/Shift klik i srednji taster prepušteni su pregledaču (otvaranje u novom tabu).
function ItemLink({ href, onActivate, className, children }: { href?: string; onActivate: () => void; className?: string; children: React.ReactNode }) {
    if (!href) {
        return (
            <div className={className} onClick={onActivate}>
                {children}
            </div>
        );
    }
    return (
        <a
            href={href}
            className={`${className || ''} no-underline`}
            onClick={(e) => {
                if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                e.preventDefault();
                onActivate();
            }}
        >
            {children}
        </a>
    );
}

export default ItemLink;
